import { Component, EventEmitter, Input, Output, signal, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidatorFn } from '@angular/forms';
import { MatSidenav } from '@angular/material/sidenav';
import { FilterType } from '@app/shared/enums/common.enums';
import { Filter } from '@app/shared/models/common.model';

@Component({
    selector: 'app-filter-drawer',
    templateUrl: './filter-drawer.component.html',
    standalone: false
})
export class FilterDrawerComponent {
  @Input() filters: Map<string, Filter> = new Map();
  public filtersForm!: FormGroup;
  readonly panelOpenState = signal(false);
  activeFilters: string[] = [];
  filterType = FilterType;
  @Output() applyFilters: EventEmitter<any> = new EventEmitter<any>();
  @Output() clearFilters: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('filterDrawer', { static: true }) drawer!: MatSidenav;

  constructor(private formBuilder: FormBuilder) {}

  ngOnInit() {
    this.createForm();
  }

  private createForm() {
    const formGroup: { [key: string]: any; } = {};
    this.activeFilters = [...this.filters.keys()];
    this.activeFilters.forEach((field) => {
      if (this.filters.get(field)?.type == FilterType.DateRange) {
        formGroup[field] = new FormGroup({
          [`${field}Start`]: new FormControl(null),
          [`${field}End`]: new FormControl(null)
        }, { validators: this.dateRangeValidator(field) });
      } else {
        formGroup[field] = [];
      }
    });
    this.filtersForm = this.formBuilder.group(formGroup);
  }

  private dateRangeValidator(field: string): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      const group = control as FormGroup;

      const start = group.get(`${field}Start`)?.value;
      const end = group.get(`${field}End`)?.value;

      if ((start && !end) || !start && end) {
        return { 'invalidRange': true };
      }

      return null;
    };
  }

  toggleAll(event: Event, filter: string) {
    const formControl = this.filtersForm.get(filter);
    const options = this.filters.get(filter)?.options || [];
    const allSelected = this.isAllSelected(filter);

    if (formControl) {
      if (allSelected) {
        formControl.setValue([]);
      } else {
        formControl.setValue(options);
      }
    }
    event.stopPropagation();
  }

  isAllSelected(filter: string): boolean {
    const filters = this.filtersForm.get(filter)?.value
    const options = this.filters.get(filter)?.options || [];    
    return options.every((option: any) => filters?.includes(option));
  }

  public toggleFilters() {
    if (this.drawer) {
      this.drawer.toggle();
    }
  }

  public onApplyFilters() {
    this.activeFilters.forEach(field => {
      if (this.filters.get(field)?.type == FilterType.MultiSelect) {
        this.filtersForm.value[field] = this.filtersForm.value[field]?.filter((x: any) => x !== undefined);
      } 
    });
    this.applyFilters.emit(this.filtersForm.value);
  }

  public onClearFilters() {
    this.filtersForm.reset();
    this.clearFilters.emit();
  }
}
